<template>
  <a
    :href="`mailto:${settings.email}`"
    class="communication-channel-item"
  >
    <div class="communication-channel-item__logo" />
  </a>
</template>

<script lang="ts">
export default defineComponent({
  name: 'EmailChannel',

  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
});
</script>

<style lang="scss" scoped>
.communication-channel-item {
  &__logo {
    background-image: url('./images/email.svg');
    width: 24px;
    height: 24px;
  }
}
</style>
